import React from 'react'
import { Link } from 'react-router-dom';

import Image from "../../asserts/images/e.png" ;
import grid from"../../asserts/images/grid2.png" ;

function Header2() {
  return (
    <div className='header2'>
<       div className='image_profil'>
            <img src={Image}></img>
            <p >BIENVENUE Ammar Dalel</p>
        </div>   
        <div className='grid'>      
          <Link to="/Espaceetudiant"> <img src={grid}></img></Link>
        </div> 

    </div>
  )
}

export default Header2